import React from "react";
import T from "prop-types";

import { GridResult } from "2g-grid";

import useSmlouvyGrid from "./useSmlouvyGrid";

export function SmlouvyGrid({ ico }) {
  const grid = useSmlouvyGrid({ ico });
  return <GridResult {...grid} />;
}

SmlouvyGrid.propTypes = { ico: T.string };

export default React.memo(SmlouvyGrid);
